/*
*  The current event types listened to are listed in eventTypes array.
*  Add additional event types as needed.
 */
const eventTypes = [
    'keypress',
    'mousemove',
    'mousedown',
    'scroll',
    'touchmove',
    'pointermove'
]
/*
 * addEventListeners function adds an event listener to the window object
 * If we call this function and pass a listener, it will call the callback function which in this
 * case is listener
 */
export const addEventListeners = (listener:any) => {
    eventTypes.forEach((type) => {
        window.addEventListener(type, listener, false)
    })
}

/*
 * removeEventListeners function removes an event listener from the window object
 *
 */
export const removeEventListeners = (listener: any) => {
    if (listener) {
        eventTypes.forEach((type) => {
            window.removeEventListener(type, listener, false)
        })
    }
}
